<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.student.studentAdd') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="mt-6">
                        <v-col cols="12">
                            <v-text-field
                                :rules="[rules.required]"
                                :label="$vuetify.lang.t('$vuetify.custom.student.name')+'*'"
                                v-model="formData.name"
                            ></v-text-field>
                        </v-col>
                        <!--<v-col cols="12">
                            <v-text-field
                                :label="$vuetify.lang.t('$vuetify.custom.student.idCard')+'*'"
                                :rules="rules.idCard"
                                v-model="formData.idCard"
                            ></v-text-field>
                        </v-col>-->
                        <!--<v-col cols="12">
                            <v-text-field
                                :label="$vuetify.lang.t('$vuetify.custom.student.age')+'*'"
                                v-model="formData.age"
                            ></v-text-field>
                        </v-col>-->
                        <!--<v-col cols="12">
                            <v-text-field
                                :rules="lengthRules"
                                :label="$vuetify.lang.t('$vuetify.custom.student.icePerson')+'*'"
                                v-model="formData.emergencyPerson"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :rules="lengthRules"
                                :label="$vuetify.lang.t('$vuetify.custom.student.iceCall')+'*'"
                                v-model="formData.emergencyCall"
                            ></v-text-field>
                        </v-col>-->
                        <!--<v-col cols="12">
                            <v-radio-group v-model="formData.gender" row>
                                <v-radio :label="$vuetify.lang.t('$vuetify.custom.student.man')" :value="0"></v-radio>
                                <v-radio :label="$vuetify.lang.t('$vuetify.custom.student.women')" :value="1"></v-radio>
                            </v-radio-group>
                        </v-col>-->
                        <!--<v-col cols="12">
                            <v-select
                                :items="classItems"
                                :label="$vuetify.lang.t('$vuetify.custom.student.class')"
                                hide-details
                                solo
                                v-model="formData.classId"
                                readonly
                            ></v-select>
                            <el-select disabled style="width: 33vw" v-model="formData.classId" filterable
                                       placeholder="选择">
                                <el-option
                                    v-for="item in classItems"
                                    :key="item.value"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </v-col>-->
                        <v-col cols="12">
<!--                            <v-select-->
<!--                                :items="schoolItems"-->
<!--                                :label="$vuetify.lang.t('$vuetify.custom.student.school')"-->
<!--                                hide-details-->
<!--                                solo-->
<!--                                v-model="formData.schoolId"-->
<!--                                :rules="[rules.required]"-->
<!--                            ></v-select>-->
                            <el-select style="width: 33vw" v-model="formData.schoolId" filterable
                                       placeholder="选择学校">
                                <el-option
                                    v-for="item in schoolItems"
                                    :key="item.value"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </v-col>
                       <!-- <v-col cols="12">
                            <v-select
                                :items="sourceItems"
                                :label="$vuetify.lang.t('$vuetify.custom.student.source')"
                                hide-details
                                solo
                                v-model="formData.sourceType"
                                :rules="[rules.required]"
                            ></v-select>
                            <el-select style="width: 33vw" v-model="formData.sourceType" filterable
                                       placeholder="选择来源">
                                <el-option
                                    v-for="item in sourceItems"
                                    :key="item.value"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </v-col>-->
                        <!--<v-col cols="12">
                            <el-select style="width: 33vw" v-model="formData.studentType" filterable
                                       placeholder="选择学生类型">
                                <el-option
                                    v-for="item in studentItems"
                                    :key="item.value"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </v-col>-->
                        <v-col cols="12">
                            <v-text-field
                                type="number"
                                :rules="etoakNoRules"
                                :label="$vuetify.lang.t('$vuetify.custom.student.outNum')+'*'"
                                v-model="formData.etoakNo"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" dark @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}
                </v-btn>
                <v-btn color="success" dark @click="addStudent">{{ $vuetify.lang.t('$vuetify.custom.student.update') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style></style>
<script>
    export default {
        name: 'student-update',
        model: {
            prop: 'dialog',
            event: 'parent-event'
        },
        props: {
            dialog: Boolean,
        },
        mounted(){
            this.initSelect();
        },
        data: () => ({
            formData: {
                id:'',
                name: '',
                //gender: '',
                //age: '',
                etoakNo:'',
                classId: '',
                schoolId: '',
                sourceType: '',
                emergencyPerson:'',
                emergencyCall:'',
                studentType:'',
                idCard:'',
            },
            lengthRules: [
                v => ((v && v.length <= 32) || v == '' || v == null) || '长度不能超过32位',
            ],
            rules: {
                required:[value => !!value || '请输入'],
                idCard: [value => {
                    if(value) {
                        const pattern = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
                        return pattern.test(value) || '请输入正确的身份证'
                    }
                }],
            },
            etoakNoRules: [
                v => !!v || '编号必填',
                v => (v.length >= 3 && v < 9999 && v > 0) || '001到9999',
            ],
            classItems: [
                {text: '选择班级', value: ''},
            ],
            schoolItems: [
                {text: '选择学校', value: ''},
            ],
            sourceItems:[
                {text: '选择来源', value: ''},
                {text: '市场招生', value: 1},
                {text: '外包推荐', value: 2},
                {text: '青岛分公司', value: 3},
            ],
            studentItems:[
                {text: '普通', value: 1},
                {text: '重修', value: 2},
                {text: '预科', value: 3},
            ],
        }),
        methods: {
            initSelect(){
                //加载所有班级
                this.$api.classList.getAllClass().then(data => {
                    if(data.data){
                        data.data.forEach(obj => {
                            this.classItems.push({text:obj.className,value:obj.id})
                        })
                    }
                })

                //加载所有学校
                this.$api.school.getSchoolSelect().then(data => {
                    if(data.data){
                        data.data.forEach(obj => {
                            this.schoolItems.push({text:obj.schoolName,value:obj.id})
                        })
                    }
                })

            },
            hiddenDialog() {
                this.$emit('parent-event', false);
            },
            addStudent() {
                if (this.$refs.form.validate()) {
                    this.$api.student.addStudent(this.formData).then(data => {
                      if (data.flag) {
                        this.$dialog.alert("添加成功");
                        this.$emit('initialize')
                        this.hiddenDialog();
                      }else{
                        this.$dialog.alert(data.msg)
                      }
                    })
                }else {
                    this.$dialog.alert("请填写相关信息");
                }
            }
        },
    }
</script>
